import React from 'react';
import {IBaseAppModel} from './model/appModel';
import config from './service/config';
import './static/css/index-embed.less';
import StateProvider from './context/stateProvider';
import {BrowserRouter} from 'react-router-dom';
import NoAccess from './component/noAccess/NoAccess';
import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';
import {createRoot} from 'react-dom/client';

export default (model: IBaseAppModel) => {
   const noAccessRoot = document.getElementById('no-access-root');

   document.body.classList.add('app-body');

   config.initWhatsNew(model);

   createRoot(noAccessRoot).render(
      <DndProvider backend={HTML5Backend}>
         <BrowserRouter>
            <StateProvider>
               <NoAccess />
            </StateProvider>
         </BrowserRouter>
      </DndProvider>
   );
};